import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { classnames } from 'Utils/classnames';
import { Badge } from 'Components/Badge';
import Icon from 'Components/Icon';

class Accordion extends Component {

  static propTypes = {
    iconName: PropTypes.string,
    title: PropTypes.string,
    children: PropTypes.any,
    isActive: PropTypes.bool,
    className: PropTypes.string,
    newBadge: PropTypes.bool,
    h2Tag: PropTypes.bool,
  };

  constructor (props) {
    super(props);

    this.state = {
      isActive: this.props.isActive || false
    };
  }

  toggleAccordion = () => {
    this.setState(prevState => ({
      isActive: !prevState.isActive
    }));
  };


  render () {
    const { iconName, title, className, children, newBadge, h2Tag } = this.props;

    const componentClass = classnames({
      accordion: true,
      'accordion--active': this.state.isActive,
      [className]: className
    });

    return (
      <div data-test="accordion" className={ componentClass }>
        { iconName && (
          <div data-test="accordion-icon" className="accordion__icon">
            <i className={ `bly ${ iconName } bly-black-white bly-size20` } />
          </div>
        ) }

        <div className="accordion__title" onClick={ this.toggleAccordion }>
          { h2Tag ? <h2 className='accordion__title' data-test="accordion-title" dangerouslySetInnerHTML={ { __html: title } } /> : <span data-test="accordion-title" dangerouslySetInnerHTML={ { __html: title } } /> }
          { newBadge ? <Badge isNew={ true } className= 'accordion-badge'>Yeni</Badge> : null }
          { !this.state.isActive ? (
            <Icon className="accordion__status-icon" iconName={ 'svgArrowUp' } />
          ) : (
            <Icon className="accordion__status-icon" iconName={ 'svgDownArrow' } />
          ) }
        </div>
        <div className="accordion__content animated fadeIn faster">
          { children }
        </div>
        <hr className="accordion__horizontal-line" />

      </div>
    );
  }
}

export default Accordion;
